import axios from "axios";

export const API_URL = `${process.env.REACT_APP_API_URL}/logs`;


// READ
export function getAllLogs() {
    return axios.get(API_URL);
}


export function getPaginatedLogs(queryParams) {
    return axios.post(`${API_URL}/list`, { ...queryParams });
}
